import React from "react"
import { motion } from "framer-motion"
import { useHistory } from "react-router-dom"
import { fireStore } from "../firebase/firebase"
import { useAuth } from "../firebase/useAuth"
import { useStore } from "../context/context"

export const GoFreeComfirmation = () => {
  const [currentUser] = useAuth()
  const { dispatch } = useStore()
  const history = useHistory()

  const goBack = () => history.goBack()
  
  const comfirmGoFree = () => {
    // REMOVE STRIPE MONTHLY PAYMENT HERE

    fireStore.collection("users").doc(currentUser?.uid).update({
      subscriptionType: "free"
    }).then(() => {
      dispatch({ 
        type: "SET_NOTIFICATION", payload: "Votre abonnement à été changé, le prélévement mensuel à été annulé" 
      })
      history.push("/")
    }).catch(err => {
      dispatch({ type: "SET_NOTIFICATION", payload: {
        type: "error",
        title: `Il y a eu un problème lors du changement : ${err}`
      }})
    })
  }

	return (
		<motion.div
			className="goFree comfirmation"
			initial={{ opacity: 0 }}
			animate={{ opacity: 1 }}
			exit={{ opacity: 0 }}
		>
			<div className="goFreeBox">
				<h2 className="title">
					Êtes-vous sûre de vouloir arrêter votre abonnement ?
				</h2>
				<p className="text">
					En désactivant votre abonnement premium, vous ne pourrez plus
					plannifier plus de 8 posts, vous ne perdrez pas vos posts déjà créés
					et pourrez réactiver le compte à tout moment.
				</p>
				<div className="buttonsRow">
					<button className="btn cancelBtn" onClick={goBack}>
						Annuler
					</button>
					<button className="btn comfirmBtn" onClick={comfirmGoFree}>Valider mon changement</button>
				</div>
			</div>
		</motion.div>
	)
}
